export default __webpack_public_path__ + "static/media/LabBackground.1e70e35c.svg";